export enum Events {
    GLOBAL_ERROR = 'GLOBAL_ERROR',
    USER_INTERACTION = 'interaction'
}
